declare type InputPropsVariant = 'success' | 'error' | 'default'

type FieldState = {
    error?: {
        message?: string
    }
    isTouched?: boolean
}

type FormState = {
    isSubmitted?: boolean
}

export const onlyNumbersOnChange = (newValue: string = '', currentValue: string = '') =>
    RegExp(/^(|[0-9]\d*)(\d+)?$/).test(newValue) ? newValue : currentValue

export const getFieldError = ({ error, isTouched }: Partial<FieldState>, { isSubmitted }: Partial<FormState>) => {
    const supportMessage: undefined | string = error && (isTouched || isSubmitted) ? error.message || undefined : undefined
    const variant = error && (isTouched || isSubmitted) ? 'error' : 'default'

    return { supportMessage, variant } as { supportMessage: string | undefined; variant: InputPropsVariant }
}
